import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

// Tailwind CSS class name utility
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

// Export all utilities for easier imports
// Export specific items to avoid naming conflicts
export {
  calculateSLATime,
  formatDate as formatCaseDate, // Renamed to avoid conflict
  formatCaseId,
  formatStatus,
  getStatusColors,
} from './cases';
export { copyToClipboard } from './clipboard';
export {
  calculateDuration,
  formatDate,
  formatDateShort,
  formatTime,
  getRelativeTime,
} from './date';
export { parseUIGroups, parseWorkflowUISchema, validateField } from './formSchema';
export { calculateSLA } from './sla';
export { getHeaderBadge, getStatusActions, getStatusColor, getStatusLabel } from './status';
export { createCookieKey, currentUser, removeCurrentUser, saveCurrentUser } from './user';
